import React, { useEffect } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { useApplicationContext } from '../../contexts/appContext'

export const EastVenturesUnAuth = () => {
  const { expire, getToken } = useApplicationContext()
  useEffect(() => {
    expire(getToken())
  }, [])

  return (
    <>
      <h1 className={'text-3xl sm:text-4xl mb-8 leading-tight'}>Unfortunately your session or code has expired.</h1>
      <BaseCard className='mt-0 max-w-screen-md mb-8' data-testid='error'>
        <div>
          <p data-testid={'modal-primary-content'}>We are unable to proceed.</p>
          <p data-testid={'modal-error-content'}>
            If the issue persists, please let Verifier know by email at{' '}
            <a href='mailto:contact@verifier.me' id='dataCollectProgress-errorContact-link'>
              contact@verifier.me
            </a>
            , and this will be investigated further.
          </p>
        </div>
      </BaseCard>
    </>
  )
}
